import { variantStackedTextImageBlock as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';

export const TestData = {
  eyebrow: 'test',
  headline: 'am I optional? lol',
  header: "Let's write your next chapter together.",
  bodyText:
    "Everyone has a story. It's the unique stories of the people who make up the Engel & Völkers network paired with a shared passion and ethos of leadership that make us unmistakable. See if Engel & Völkers is the right company for you to call home.",
  imgs: {
    desktop: '/textimageplaceholder.png',
    mobile: '/textimageplaceholder.png',
  },
  ctaText: 'Learn More',
  ctaUrl: '#',
  reverse: true,
  stats: [
    {
      statNumber: 3000,
      subheader: 'Expert Advisors',
      append: '+',
    },
    {
      statNumber: 832,
      subheader: 'Shops in Americas',
    },
    {
      statNumber: 65,
      subheader: 'Countries',
      append: '+',
    },
    {
      statNumber: 74,
      subheader: 'Shops Globally',
    },
  ],
};

export default fakeProps(schema, TestData);
